import WebpackerReact from 'webpacker-react'

import PubAnnotations from '../react/annotations/PubAnnotations'
import DesignerAnnotation from '../react/annotations/DesignerAnnotation'
import ResolvedAnnotationsHandler from '../components/ResolvedAnnotationsHandler'
import SwipeCarouselNavigation from '../components/SwipeCarouselNavigation'

export default class PublicationJobsAnnotations {
  constructor(params) {
    this.params = params;
  }

  unload() {
    PubAnnotations.unload()
  }

  index() {
    // unload here in event user pushed back in browser
    PubAnnotations.unload()
    const page = this.params.page || 1;
    if ($('img.js-annotation-boundry').length) {
      let img = new Image()
      img.src = $('img.js-annotation-boundry')[0].src
      img.onload = () => {
        this.pubAnnotations = PubAnnotations.init(page, this.params.pagesPerSheet);
        this.listen()
        this.setupResolvedHandler()
      }
    } else if (!$('.js-no-finished-asset').length) {
      this.pubAnnotations = PubAnnotations.init(page, this.params.pagesPerSheet);
      this.listen()
      this.setupResolvedHandler()
    }
    if (!$('.js-no-finished-asset').length) {
      new SwipeCarouselNavigation();
    }
  }

  new() {
    WebpackerReact.setup({DesignerAnnotation})
  }

  edit(){
    WebpackerReact.setup({DesignerAnnotation}) 
  }

  listen() {
    // Move left and right through pagination
    // with arrow keys
    $(document).on('keydown', (e) => {
      switch(e.which) {
        // left
        case 37:
        if (this.noOpenAnnotations()) {
          $('a[rel=prev]').children()[0].click()
        }
        break;
        // right
        case 39:
        if (this.noOpenAnnotations()) {
          $('a[rel=next]').children()[0].click()
        }
        break;
        default: return;
      }
    })
  }

  noOpenAnnotations() {
    return !$('.annotation-container.is-open').length;
  }

  setupResolvedHandler() {
    let currAnno = $.grep(this.pubAnnotations.annotations, (anno) => { return anno.id == this.params.currentAnnotation; })[0] || {};
    // has to come after annotations init
    new ResolvedAnnotationsHandler({resolved: currAnno.resolved})
  }
}
